var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTpFulfilledIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TP-fulfilled-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.563,
    height: 44.57,
    viewBox: "0 0 44.563 44.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_17",
    "data-name": "Vereinigungsmenge 17",
    d: "M12467.5,22144.563a22.281,22.281,0,1,1,22.287,22.285A22.289,22.289,0,0,1,12467.5,22144.563Zm14-19.605a21.264,21.264,0,1,0,8.289-1.68A21.107,21.107,0,0,0,12481.5,22124.957Zm6.441,29.152a1.189,1.189,0,0,1-.744-.5l-5.486-8.035a1.18,1.18,0,0,1,.313-1.637,1.165,1.165,0,0,1,1.623.313l4.5,6.586,9.068-13.973a1.173,1.173,0,0,1,1.969,1.277l-10.025,15.457a1.185,1.185,0,0,1-.967.523c-.027,0-.053,0-.076,0A1.221,1.221,0,0,1,12487.939,22154.109Z",
    transform: "translate(-12467.5 -22122.277)",
    fill: "#31c485"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpFulfilledIndicator);
export default __webpack_public_path__ + "static/media/tpFulfilledIndicator.407f70f386501f3faa520187284b1bd9.svg";
export { ForwardRef as ReactComponent };